<template>
    <div class="m-userinfo">

        <p class="info-txt">
            <span>欢迎，</span>
            <span class="area-name" v-if="$store.state.login && $store.state.userinfo.zid">【{{ area_dic[$store.state.userinfo.zid] }}】</span>
            <span class="player-name">{{ ($store.state.userinfo.nickName || uid_handler($store.state.userinfo.uid) )|e }}</span>
            
            <span v-if="($store.state.login && !$store.state.userinfo.zid)" class="bind" @click="$bind_modal()">【绑定大区】</span>
            <span v-if="$store.state.login && $store.state.userinfo.zid" class="bind" @click="$bind_modal()">【切换大区】</span>
            <span v-if="$store.state.login && !KD.isApp() && $store.state.userinfo.uid" class="logout" @click="call_logout">【退出】</span>
            <span v-if="!$store.state.login || !$store.state.userinfo.uid" class="login" @click="call_login">【登录】</span>            
        </p>
       
    </div>
</template>

<script>
import KD from '@/assets/js/kd.js';
// import mslogin from '@/assets/js/espassport.esm.min';
import area_dic from '@/components/areadic.js';
import { token_type } from '@/api/config';

export default {
    data (){
        return {
            KD : KD,
            area_dic : area_dic,
        }
    },
    props : {
        info : {
            default : () => {}
        },
        login_flag : {
            default : 0,
        },
    },
    filters : {
        e(str) {return str || '仙术师'}
    },    
    methods : {
        call_login(){
            this.$mslogin.login();
        },

        call_logout(){
            var _this = this;
            //localStorage.clear();
            localStorage.removeItem(token_type);
            localStorage.removeItem('account');
            localStorage.removeItem('userinfo');
            localStorage.removeItem('login');

            setTimeout(function () { 
                //TODO   
                document.location = _this.$global.domain;
            }, 100);             
        },

        call_buy (){

            if(!this.$store.state.userinfo.uid){
                return this.$mslogin.login();
            }

            if(!this.$store.state.userinfo.areaId){
                this.$toast('请绑定大区');
                return this.$bind_modal();
            }            

            this.$buy_Modal();
        },

        switch_area (){
            this.$close_book();
            this.$bind_modal();
        },

        uid_handler(uid){
            return uid ? uid.toString().slice(0,6) + '****' : '仙术师'    
        },
    },
}
</script>

<style scoped>
    .m-userinfo{
        text-align: center;
        z-index: 10;
        /* color: #dccdc1; */
    }

    .info{ 
        /* width: 350px; */
        word-break: break-all;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;        
    }

    .logout,
    .login{        
        color: #d35940;
    }

    .area-name{
        padding: 0 10px;
    }

    .player-name{
        padding-right: 14px;
    }

    .login-state{
        /* height: 30px;
        line-height: 30px; */
    }

    .info-text{
        /*display: flex;
        justify-content: center;*/
    }

    .ui{
        margin-top: 10px;
        padding-left: 10px;
        font-size: 24px;
        color: #d35940;
    }

    .bind{
        color: #d35940;
        /* padding-right: 20px;
    }

    .ui span{
        /* text-decoration: underline; */
    }

    /* @media not all and (min-width:900px){
        .m-userinfo{
            width: 750px;
            justify-content: center;
            font-size: 24px;
        }
    } */
</style>